module.exports = [
  { name: 'Acid Green', value: '#8FFE09' },
  { name: 'Adobe', value: '#BD6C48' },
  { name: 'Algae Green', value: '#21C36F' },
  { name: 'Algae', value: '#54AC68' },
  { name: 'Almost Black', value: '#070D0D' },
  { name: 'Amber', value: '#FEB308' },
  { name: 'Amethyst', value: '#9B5FC0' },
  { name: 'Apple Green', value: '#76CD26' },
  { name: 'Apple', value: '#6ECB3C' },
  { name: 'Apricot', value: '#FFB16D' },
  { name: 'Aqua Blue', value: '#02D8E9' },
  { name: 'Aqua Green', value: '#12E193' },
  { name: 'Aquamarine', value: '#04D8B2' },
  { name: 'Aqua Marine', value: '#2EE8BB' },
  { name: 'Aqua', value: '#13EAC9' },
  { name: 'Army Green', value: '#4B5D16' },
  { name: 'Asparagus', value: '#77AB56' },
  { name: 'Aubergine', value: '#3D0734' },
  { name: 'Auburn', value: '#9A3001' },
  { name: 'Avocado Green', value: '#87A922' },
  { name: 'Avocado', value: '#90B134' },
  { name: 'Azul', value: '#1D5DEC' },
  { name: 'Azure', value: '#069AF3' },
  { name: 'Baby Blue', value: '#A2CFFE' },
  { name: 'Baby Green', value: '#8CFF9E' },
  { name: 'Baby Pink', value: '#FFB7CE' },
  { name: 'Baby Poop Green', value: '#8F9805' },
  { name: 'Baby Poop', value: '#937C00' },
  { name: 'Baby Poo', value: '#AB9004' },
  { name: 'Baby Puke Green', value: '#B6C406' },
  { name: 'Baby Purple', value: '#CA9BF7' },
  { name: 'Baby Crap Brown', value: '#AD900D' },
  { name: 'Baby Crap Green', value: '#889717' },
  { name: 'Banana', value: '#FFFF7E' },
  { name: 'Banana Yellow', value: '#FAFE4B' },
  { name: 'Barbie Pink', value: '#FE46A5' },
  { name: 'Barf Green', value: '#94AC02' },
  { name: 'Barney Purple', value: '#A00498' },
  { name: 'Barney', value: '#AC1DB8' },
  { name: 'Battleship Grey', value: '#6B7C85' },
  { name: 'Beige', value: '#E6DAA6' },
  { name: 'Berry', value: '#990F4B' },
  { name: 'Bile', value: '#B5C306' },
  { name: 'Black', value: '#000000' },
  { name: 'Bland', value: '#AFA88B' },
  { name: 'Blood Orange', value: '#FE4B03' },
  { name: 'Blood Red', value: '#980002' },
  { name: 'Blood', value: '#770001' },
  { name: 'Blueberry', value: '#464196' },
  { name: 'Blue Blue', value: '#2242C7' },
  { name: 'Bluegreen', value: '#017A79' },
  { name: 'Blue Green', value: '#0F9B8E' },
  { name: 'Blue Green', value: '#137E6D' },
  { name: 'Blue Grey', value: '#607C8E' },
  { name: 'Blue Grey', value: '#758DA3' },
  { name: 'Bluegrey', value: '#85A3B2' },
  { name: 'Blue Purple', value: '#5729CE' },
  { name: 'Blue Purple', value: '#5A06EF' },
  { name: 'Blue', value: '#0343DF' },
  { name: 'Blue Violet', value: '#5D06E9' },
  { name: 'Blue with a Hint of Purple', value: '#533CC6' },
  { name: 'Bluey Green', value: '#2BB179' },
  { name: 'Bluey Grey', value: '#89A0B0' },
  { name: 'Bluey Purple', value: '#6241C7' },
  { name: 'Bluish Green', value: '#10A674' },
  { name: 'Bluish Grey', value: '#748B97' },
  { name: 'Bluish Purple', value: '#703BE7' },
  { name: 'Bluish', value: '#2976BB' },
  { name: 'Blurple', value: '#5539CC' },
  { name: 'Blush Pink', value: '#FE828C' },
  { name: 'Blush', value: '#F29E8E' },
  { name: 'Booger Green', value: '#96B403' },
  { name: 'Booger', value: '#9BB53C' },
  { name: 'Bordeaux', value: '#7B002C' },
  { name: 'Boring Green', value: '#63B365' },
  { name: 'Bottle Green', value: '#044A05' },
  { name: 'Brick Orange', value: '#C14A09' },
  { name: 'Brick Red', value: '#8F1402' },
  { name: 'Brick', value: '#A03623' },
  { name: 'Bright Aqua', value: '#0BF9EA' },
  { name: 'Bright Blue', value: '#0165FC' },
  { name: 'Bright Cyan', value: '#41FDFE' },
  { name: 'Bright Green', value: '#01FF07' },
  { name: 'Bright Lavender', value: '#C760FF' },
  { name: 'Bright Light Blue', value: '#26F7FD' },
  { name: 'Bright Light Green', value: '#2DFE54' },
  { name: 'Bright Lilac', value: '#C95EFB' },
  { name: 'Bright Lime Green', value: '#65FE08' },
  { name: 'Bright Lime', value: '#87FD05' },
  { name: 'Bright Magenta', value: '#FF08E8' },
  { name: 'Bright Olive', value: '#9CBB04' },
  { name: 'Bright Orange', value: '#FF5B00' },
  { name: 'Bright Pink', value: '#FE01B1' },
  { name: 'Bright Purple', value: '#BE03FD' },
  { name: 'Bright Red', value: '#FF000D' },
  { name: 'Bright Sea Green', value: '#05FFA6' },
  { name: 'Bright Sky Blue', value: '#02CCFE' },
  { name: 'Bright Teal', value: '#01F9C6' },
  { name: 'Bright Turquoise', value: '#0FFEF9' },
  { name: 'Bright Violet', value: '#AD0AFD' },
  { name: 'Bright Yellow Green', value: '#9DFF00' },
  { name: 'Bright Yellow', value: '#FFFD01' },
  { name: 'British Racing Green', value: '#05480D' },
  { name: 'Bronze', value: '#A87900' },
  { name: 'Brown Green', value: '#706C11' },
  { name: 'Brown Grey', value: '#8D8468' },
  { name: 'Brownish Green', value: '#6A6E09' },
  { name: 'Brownish Grey', value: '#86775F' },
  { name: 'Brownish Orange', value: '#CB7723' },
  { name: 'Brownish Pink', value: '#C27E79' },
  { name: 'Brownish Purple', value: '#76424E' },
  { name: 'Brownish Red', value: '#9E3623' },
  { name: 'Brownish', value: '#9C6D57' },
  { name: 'Brownish Yellow', value: '#C9B003' },
  { name: 'Brown Orange', value: '#B96902' },
  { name: 'Brown Red', value: '#922B05' },
  { name: 'Brown', value: '#653700' },
  { name: 'Brown Yellow', value: '#B29705' },
  { name: 'Browny Green', value: '#6F6C0A' },
  { name: 'Browny Orange', value: '#CA6B02' },
  { name: 'Bruise', value: '#7E4071' },
  { name: 'Bubblegum Pink', value: '#FE83CC' },
  { name: 'Bubble Gum Pink', value: '#FF69AF' },
  { name: 'Bubblegum', value: '#FF6CB5' },
  { name: 'Buff', value: '#FEF69E' },
  { name: 'Burgundy', value: '#610023' },
  { name: 'Burnt Orange', value: '#C04E01' },
  { name: 'Burnt Red', value: '#9F2305' },
  { name: 'Burnt Siena', value: '#B75203' },
  { name: 'Burnt Sienna', value: '#B04E0F' },
  { name: 'Burnt Umber', value: '#A0450E' },
  { name: 'Burnt Yellow', value: '#D5AB09' },
  { name: 'Burple', value: '#6832E3' },
  { name: 'Butterscotch', value: '#FDB147' },
  { name: 'Butter', value: '#FFFF81' },
  { name: 'Butter Yellow', value: '#FFFD74' },
  { name: 'Cadet Blue', value: '#4E7496' },
  { name: 'Camel', value: '#C69F59' },
  { name: 'Camo Green', value: '#526525' },
  { name: 'Camouflage Green', value: '#4B6113' },
  { name: 'Camo', value: '#7F8F4E' },
  { name: 'Canary', value: '#FDFF63' },
  { name: 'Canary Yellow', value: '#FFFE40' },
  { name: 'Candy Pink', value: '#FF63E9' },
  { name: 'Caramel', value: '#AF6F09' },
  { name: 'Carmine', value: '#9D0216' },
  { name: 'Carnation Pink', value: '#FF7FA7' },
  { name: 'Carnation', value: '#FD798F' },
  { name: 'Carolina Blue', value: '#8AB8FE' },
  { name: 'Celadon', value: '#BEFDB7' },
  { name: 'Celery', value: '#C1FD95' },
  { name: 'Cement', value: '#A5A391' },
  { name: 'Cerise', value: '#DE0C62' },
  { name: 'Cerulean Blue', value: '#056EEE' },
  { name: 'Cerulean', value: '#0485D1' },
  { name: 'Charcoal Grey', value: '#3C4142' },
  { name: 'Charcoal', value: '#343837' },
  { name: 'Chartreuse', value: '#C1F80A' },
  { name: 'Cherry Red', value: '#F7022A' },
  { name: 'Cherry', value: '#CF0234' },
  { name: 'Chestnut', value: '#742802' },
  { name: 'Chocolate Brown', value: '#411900' },
  { name: 'Chocolate', value: '#3D1C02' },
  { name: 'Cinnamon', value: '#AC4F06' },
  { name: 'Claret', value: '#680018' },
  { name: 'Clay Brown', value: '#B2713D' },
  { name: 'Clay', value: '#B66A50' },
  { name: 'Clear Blue', value: '#247AFD' },
  { name: 'Cloudy Blue', value: '#ACC2D9' },
  { name: 'Cobalt Blue', value: '#030AA7' },
  { name: 'Cobalt', value: '#1E488F' },
  { name: 'Cocoa', value: '#875F42' },
  { name: 'Coffee', value: '#A6814C' },
  { name: 'Cool Blue', value: '#4984B8' },
  { name: 'Cool Green', value: '#33B864' },
  { name: 'Cool Grey', value: '#95A3A6' },
  { name: 'Copper', value: '#B66325' },
  { name: 'Coral Pink', value: '#FF6163' },
  { name: 'Coral', value: '#FC5A50' },
  { name: 'Cornflower Blue', value: '#5170D7' },
  { name: 'Cornflower', value: '#6A79F7' },
  { name: 'Cranberry', value: '#9E003A' },
  { name: 'Crap Brown', value: '#7B5804' },
  { name: 'Crap Green', value: '#758000' },
  { name: 'Crap', value: '#7F5F00' },
  { name: 'Cream', value: '#FFFFC2' },
  { name: 'Creme', value: '#FFFFB6' },
  { name: 'Crimson', value: '#8C000F' },
  { name: 'Custard', value: '#FFFD78' },
  { name: 'Cyan', value: '#00FFFF' },
  { name: 'Dandelion', value: '#FEDF08' },
  { name: 'Dark Aquamarine', value: '#017371' },
  { name: 'Dark Aqua', value: '#05696B' },
  { name: 'Dark Beige', value: '#AC9362' },
  { name: 'Dark Blue Green', value: '#005249' },
  { name: 'Dark Blue Grey', value: '#1F3B4D' },
  { name: 'Dark Blue', value: '#00035B' },
  { name: 'Darkblue', value: '#030764' },
  { name: 'Dark Brown', value: '#341C02' },
  { name: 'Dark Coral', value: '#CF524E' },
  { name: 'Dark Cream', value: '#FFF39A' },
  { name: 'Dark Cyan', value: '#0A888A' },
  { name: 'Dark Forest Green', value: '#002D04' },
  { name: 'Dark Fuchsia', value: '#9D0759' },
  { name: 'Dark Gold', value: '#B59410' },
  { name: 'Dark Grass Green', value: '#388004' },
  { name: 'Dark Green Blue', value: '#1F6357' },
  { name: 'Dark Green', value: '#033500' },
  { name: 'Darkgreen', value: '#054907' },
  { name: 'Dark Grey Blue', value: '#29465B' },
  { name: 'Dark Grey', value: '#363737' },
  { name: 'Dark Hot Pink', value: '#D90166' },
  { name: 'Dark Indigo', value: '#1F0954' },
  { name: 'Darkish Blue', value: '#014182' },
  { name: 'Darkish Green', value: '#287C37' },
  { name: 'Darkish Pink', value: '#DA467D' },
  { name: 'Darkish Purple', value: '#751973' },
  { name: 'Darkish Red', value: '#A90308' },
  { name: 'Dark Khaki', value: '#9B8F55' },
  { name: 'Dark Lavender', value: '#856798' },
  { name: 'Dark Lilac', value: '#9C6DA5' },
  { name: 'Dark Lime Green', value: '#7EBD01' },
  { name: 'Dark Lime', value: '#84B701' },
  { name: 'Dark Magenta', value: '#960056' },
  { name: 'Dark Maroon', value: '#3C0008' },
  { name: 'Dark Mauve', value: '#874C62' },
  { name: 'Dark Mint Green', value: '#20C073' },
  { name: 'Dark Mint', value: '#48C072' },
  { name: 'Dark Mustard', value: '#A88905' },
  { name: 'Dark Navy Blue', value: '#00022E' },
  { name: 'Dark Navy', value: '#000435' },
  { name: 'Dark Olive Green', value: '#3C4D03' },
  { name: 'Dark Olive', value: '#373E02' },
  { name: 'Dark Orange', value: '#C65102' },
  { name: 'Dark Pastel Green', value: '#56AE57' },
  { name: 'Dark Peach', value: '#DE7E5D' },
  { name: 'Dark Periwinkle', value: '#665FD1' },
  { name: 'Dark Pink', value: '#CB416B' },
  { name: 'Dark Plum', value: '#3F012C' },
  { name: 'Dark Purple', value: '#35063E' },
  { name: 'Dark Red', value: '#840000' },
  { name: 'Dark Rose', value: '#B5485D' },
  { name: 'Dark Royal Blue', value: '#02066F' },
  { name: 'Dark Sage', value: '#598556' },
  { name: 'Dark Salmon', value: '#C85A53' },
  { name: 'Dark Sand', value: '#A88F59' },
  { name: 'Dark Seafoam Green', value: '#3EAF76' },
  { name: 'Dark Seafoam', value: '#1FB57A' },
  { name: 'Dark Sea Green', value: '#11875D' },
  { name: 'Dark Sky Blue', value: '#448EE4' },
  { name: 'Dark Slate Blue', value: '#214761' },
  { name: 'Dark Tan', value: '#AF884A' },
  { name: 'Dark Taupe', value: '#7F684E' },
  { name: 'Dark Teal', value: '#014D4E' },
  { name: 'Dark Turquoise', value: '#045C5A' },
  { name: 'Dark', value: '#1B2431' },
  { name: 'Dark Violet', value: '#34013F' },
  { name: 'Dark Yellow Green', value: '#728F02' },
  { name: 'Dark Yellow', value: '#D5B60A' },
  { name: 'Deep Aqua', value: '#08787F' },
  { name: 'Deep Blue', value: '#040273' },
  { name: 'Deep Brown', value: '#410200' },
  { name: 'Deep Green', value: '#02590F' },
  { name: 'Deep Lavender', value: '#8D5EB7' },
  { name: 'Deep Lilac', value: '#966EBD' },
  { name: 'Deep Magenta', value: '#A0025C' },
  { name: 'Deep Orange', value: '#DC4D01' },
  { name: 'Deep Pink', value: '#CB0162' },
  { name: 'Deep Purple', value: '#36013F' },
  { name: 'Deep Red', value: '#9A0200' },
  { name: 'Deep Rose', value: '#C74767' },
  { name: 'Deep Sea Blue', value: '#015482' },
  { name: 'Deep Sky Blue', value: '#0D75F8' },
  { name: 'Deep Teal', value: '#00555A' },
  { name: 'Deep Turquoise', value: '#017374' },
  { name: 'Deep Violet', value: '#490648' },
  { name: 'Denim Blue', value: '#3B5B92' },
  { name: 'Denim', value: '#3B638C' },
  { name: 'Desert', value: '#CCAD60' },
  { name: 'Diarrhea', value: '#9F8303' },
  { name: 'Dirt Brown', value: '#836539' },
  { name: 'Dirt', value: '#8A6E45' },
  { name: 'Dirty Blue', value: '#3F829D' },
  { name: 'Dirty Green', value: '#667E2C' },
  { name: 'Dirty Orange', value: '#C87606' },
  { name: 'Dirty Pink', value: '#CA7B80' },
  { name: 'Dirty Purple', value: '#734A65' },
  { name: 'Dirty Yellow', value: '#CDC50A' },
  { name: 'Dodger Blue', value: '#3E82FC' },
  { name: 'Drab Green', value: '#749551' },
  { name: 'Drab', value: '#828344' },
  { name: 'Dried Blood', value: '#4B0101' },
  { name: 'Duck Egg Blue', value: '#C3FBF4' },
  { name: 'Dull Blue', value: '#49759C' },
  { name: 'Dull Brown', value: '#876E4B' },
  { name: 'Dull Green', value: '#74A662' },
  { name: 'Dull Orange', value: '#D8863B' },
  { name: 'Dull Pink', value: '#D5869D' },
  { name: 'Dull Purple', value: '#84597E' },
  { name: 'Dull Red', value: '#BB3F3F' },
  { name: 'Dull Teal', value: '#5F9E8F' },
  { name: 'Dull Yellow', value: '#EEDC5B' },
  { name: 'Dusk Blue', value: '#26538D' },
  { name: 'Dusk', value: '#4E5481' },
  { name: 'Dusky Blue', value: '#475F94' },
  { name: 'Dusky Pink', value: '#CC7A8B' },
  { name: 'Dusky Purple', value: '#895B7B' },
  { name: 'Dusky Rose', value: '#BA6873' },
  { name: 'Dust', value: '#B2996E' },
  { name: 'Dusty Blue', value: '#5A86AD' },
  { name: 'Dusty Green', value: '#76A973' },
  { name: 'Dusty Lavender', value: '#AC86A8' },
  { name: 'Dusty Orange', value: '#F0833A' },
  { name: 'Dusty Pink', value: '#D58A94' },
  { name: 'Dusty Purple', value: '#825F87' },
  { name: 'Dusty Red', value: '#B9484E' },
  { name: 'Dusty Rose', value: '#C0737A' },
  { name: 'Dusty Teal', value: '#4C9085' },
  { name: 'Earth', value: '#A2653E' },
  { name: 'Easter Green', value: '#8CFD7E' },
  { name: 'Easter Purple', value: '#C071FE' },
  { name: 'Ecru', value: '#FEFFCA' },
  { name: 'Eggplant Purple', value: '#430541' },
  { name: 'Eggplant', value: '#380835' },
  { name: 'Eggshell Blue', value: '#C4FFF7' },
  { name: 'Egg Shell', value: '#FFFCC4' },
  { name: 'Eggshell', value: '#FFFFD4' },
  { name: 'Electric Blue', value: '#0652FF' },
  { name: 'Electric Green', value: '#21FC0D' },
  { name: 'Electric Lime', value: '#A8FF04' },
  { name: 'Electric Pink', value: '#FF0490' },
  { name: 'Electric Purple', value: '#AA23FF' },
  { name: 'Emerald Green', value: '#028F1E' },
  { name: 'Emerald', value: '#01A049' },
  { name: 'Evergreen', value: '#05472A' },
  { name: 'Faded Blue', value: '#658CBB' },
  { name: 'Faded Green', value: '#7BB274' },
  { name: 'Faded Orange', value: '#F0944D' },
  { name: 'Faded Pink', value: '#DE9DAC' },
  { name: 'Faded Purple', value: '#916E99' },
  { name: 'Faded Red', value: '#D3494E' },
  { name: 'Faded Yellow', value: '#FEFF7F' },
  { name: 'Fawn', value: '#CFAF7B' },
  { name: 'Fern Green', value: '#548D44' },
  { name: 'Fern', value: '#63A950' },
  { name: 'Fire Engine Red', value: '#FE0002' },
  { name: 'Flat Blue', value: '#3C73A8' },
  { name: 'Flat Green', value: '#699D4C' },
  { name: 'Fluorescent Green', value: '#08FF08' },
  { name: 'Fluro Green', value: '#0AFF02' },
  { name: 'Foam Green', value: '#90FDA9' },
  { name: 'Forest Green', value: '#06470C' },
  { name: 'Forest', value: '#0B5509' },
  { name: 'Forrest Green', value: '#154406' },
  { name: 'French Blue', value: '#436BAD' },
  { name: 'Fresh Green', value: '#69D84F' },
  { name: 'Frog Green', value: '#58BC08' },
  { name: 'Fuchsia', value: '#ED0DD9' },
  { name: 'Golden Brown', value: '#B27A01' },
  { name: 'Golden Rod', value: '#F9BC08' },
  { name: 'Goldenrod', value: '#FAC205' },
  { name: 'Golden', value: '#F5BF03' },
  { name: 'Golden Yellow', value: '#FEC615' },
  { name: 'Gold', value: '#DBB40C' },
  { name: 'Grapefruit', value: '#FD5956' },
  { name: 'Grape Purple', value: '#5D1451' },
  { name: 'Grape', value: '#6C3461' },
  { name: 'Grass Green', value: '#3F9B0B' },
  { name: 'Grass', value: '#5CAC2D' },
  { name: 'Grassy Green', value: '#419C03' },
  { name: 'Green Apple', value: '#5EDC1F' },
  { name: 'Green Blue', value: '#01C08D' },
  { name: 'Green Blue', value: '#06B48B' },
  { name: 'Greenblue', value: '#23C48B' },
  { name: 'Green Brown', value: '#544E03' },
  { name: 'Green Grey', value: '#77926F' },
  { name: 'Greenish Beige', value: '#C9D179' },
  { name: 'Greenish Blue', value: '#0B8B87' },
  { name: 'Greenish Brown', value: '#696112' },
  { name: 'Greenish Cyan', value: '#2AFEB7' },
  { name: 'Greenish Grey', value: '#96AE8D' },
  { name: 'Greenish Tan', value: '#BCCB7A' },
  { name: 'Greenish Teal', value: '#32BF84' },
  { name: 'Greenish Turquoise', value: '#00FBB0' },
  { name: 'Greenish', value: '#40A368' },
  { name: 'Greenish Yellow', value: '#CDFD02' },
  { name: 'Green Teal', value: '#0CB577' },
  { name: 'Green', value: '#15B01A' },
  { name: 'Greeny Blue', value: '#42B395' },
  { name: 'Greeny Brown', value: '#696006' },
  { name: 'Green Yellow', value: '#B5CE08' },
  { name: 'Green Yellow', value: '#C9FF27' },
  { name: 'Greeny Grey', value: '#7EA07A' },
  { name: 'Greeny Yellow', value: '#C6F808' },
  { name: 'Grey Blue', value: '#647D8E' },
  { name: 'Grey Blue', value: '#6B8BA4' },
  { name: 'Greyblue', value: '#77A1B5' },
  { name: 'Grey Brown', value: '#7F7053' },
  { name: 'Grey Green', value: '#789B73' },
  { name: 'Grey Green', value: '#86A17D' },
  { name: 'Greyish Blue', value: '#5E819D' },
  { name: 'Greyish Brown', value: '#7A6A4F' },
  { name: 'Greyish Green', value: '#82A67D' },
  { name: 'Greyish Pink', value: '#C88D94' },
  { name: 'Greyish Purple', value: '#887191' },
  { name: 'Greyish Teal', value: '#719F91' },
  { name: 'Greyish', value: '#A8A495' },
  { name: 'Grey Pink', value: '#C3909B' },
  { name: 'Grey Purple', value: '#826D8C' },
  { name: 'Grey Teal', value: '#5E9B8A' },
  { name: 'Grey', value: '#929591' },
  { name: 'Gross Green', value: '#A0BF16' },
  { name: 'Gunmetal', value: '#536267' },
  { name: 'Hazel', value: '#8E7618' },
  { name: 'Heather', value: '#A484AC' },
  { name: 'Heliotrope', value: '#D94FF5' },
  { name: 'Highlighter Green', value: '#1BFC06' },
  { name: 'Hospital Green', value: '#9BE5AA' },
  { name: 'Hot Green', value: '#25FF29' },
  { name: 'Hot Magenta', value: '#F504C9' },
  { name: 'Hot Pink', value: '#FF028D' },
  { name: 'Hot Purple', value: '#CB00F5' },
  { name: 'Hunter Green', value: '#0B4008' },
  { name: 'Ice Blue', value: '#D7FFFE' },
  { name: 'Ice', value: '#D6FFFA' },
  { name: 'Icky Green', value: '#8FAE22' },
  { name: 'Indian Red', value: '#850E04' },
  { name: 'Indigo Blue', value: '#3A18B1' },
  { name: 'Indigo', value: '#380282' },
  { name: 'Irish Green', value: '#019529' },
  { name: 'Iris', value: '#6258C4' },
  { name: 'Ivory', value: '#FFFFCB' },
  { name: 'Jade Green', value: '#2BAF6A' },
  { name: 'Jade', value: '#1FA774' },
  { name: 'Jungle Green', value: '#048243' },
  { name: 'Kelley Green', value: '#009337' },
  { name: 'Kelly Green', value: '#02AB2E' },
  { name: 'Kermit Green', value: '#5CB200' },
  { name: 'Key Lime', value: '#AEFF6E' },
  { name: 'Khaki Green', value: '#728639' },
  { name: 'Khaki', value: '#AAA662' },
  { name: 'Kiwi Green', value: '#8EE53F' },
  { name: 'Kiwi', value: '#9CEF43' },
  { name: 'Lavender Blue', value: '#8B88F8' },
  { name: 'Lavender Pink', value: '#DD85D7' },
  { name: 'Lavender', value: '#C79FEF' },
  { name: 'Lawn Green', value: '#4DA409' },
  { name: 'Leaf Green', value: '#5CA904' },
  { name: 'Leaf', value: '#71AA34' },
  { name: 'Leafy Green', value: '#51B73B' },
  { name: 'Leather', value: '#AC7434' },
  { name: 'Lemon Green', value: '#ADF802' },
  { name: 'Lemon Lime', value: '#BFFE28' },
  { name: 'Lemon', value: '#FDFF52' },
  { name: 'Lemon Yellow', value: '#FDFF38' },
  { name: 'Lichen', value: '#8FB67B' },
  { name: 'Light Aquamarine', value: '#7BFDC7' },
  { name: 'Light Aqua', value: '#8CFFDB' },
  { name: 'Light Beige', value: '#FFFEB6' },
  { name: 'Light Blue Green', value: '#7EFBB3' },
  { name: 'Light Blue Grey', value: '#B7C9E2' },
  { name: 'Lightblue', value: '#7BC8F6' },
  { name: 'Light Blue', value: '#95D0FC' },
  { name: 'Light Bluish Green', value: '#76FDA8' },
  { name: 'Light Bright Green', value: '#53FE5C' },
  { name: 'Light Brown', value: '#AD8150' },
  { name: 'Light Burgundy', value: '#A8415B' },
  { name: 'Light Cyan', value: '#ACFFFC' },
  { name: 'Light Eggplant', value: '#894585' },
  { name: 'Lighter Green', value: '#75FD63' },
  { name: 'Lighter Purple', value: '#A55AF4' },
  { name: 'Light Forest Green', value: '#4F9153' },
  { name: 'Light Gold', value: '#FDDC5C' },
  { name: 'Light Grass Green', value: '#9AF764' },
  { name: 'Light Green Blue', value: '#56FCA2' },
  { name: 'Light Greenish Blue', value: '#63F7B4' },
  { name: 'Lightgreen', value: '#76FF7B' },
  { name: 'Light Green', value: '#96F97B' },
  { name: 'Light Grey Blue', value: '#9DBCD4' },
  { name: 'Light Grey Green', value: '#B7E1A1' },
  { name: 'Light Grey', value: '#D8DCD6' },
  { name: 'Light Indigo', value: '#6D5ACF' },
  { name: 'Lightish Blue', value: '#3D7AFD' },
  { name: 'Lightish Green', value: '#61E160' },
  { name: 'Lightish Purple', value: '#A552E6' },
  { name: 'Lightish Red', value: '#FE2F4A' },
  { name: 'Light Khaki', value: '#E6F2A2' },
  { name: 'Light Lavendar', value: '#EFC0FE' },
  { name: 'Light Lavender', value: '#DFC5FE' },
  { name: 'Light Light Blue', value: '#CAFFFB' },
  { name: 'Light Light Green', value: '#C8FFB0' },
  { name: 'Light Lilac', value: '#EDC8FF' },
  { name: 'Light Lime Green', value: '#B9FF66' },
  { name: 'Light Lime', value: '#AEFD6C' },
  { name: 'Light Magenta', value: '#FA5FF7' },
  { name: 'Light Maroon', value: '#A24857' },
  { name: 'Light Mauve', value: '#C292A1' },
  { name: 'Light Mint Green', value: '#A6FBB2' },
  { name: 'Light Mint', value: '#B6FFBB' },
  { name: 'Light Moss Green', value: '#A6C875' },
  { name: 'Light Mustard', value: '#F7D560' },
  { name: 'Light Navy Blue', value: '#2E5A88' },
  { name: 'Light Navy', value: '#155084' },
  { name: 'Light Neon Green', value: '#4EFD54' },
  { name: 'Light Olive Green', value: '#A4BE5C' },
  { name: 'Light Olive', value: '#ACBF69' },
  { name: 'Light Orange', value: '#FDAA48' },
  { name: 'Light Pastel Green', value: '#B2FBA5' },
  { name: 'Light Peach', value: '#FFD8B1' },
  { name: 'Light Pea Green', value: '#C4FE82' },
  { name: 'Light Periwinkle', value: '#C1C6FC' },
  { name: 'Light Pink', value: '#FFD1DF' },
  { name: 'Light Plum', value: '#9D5783' },
  { name: 'Light Purple', value: '#BF77F6' },
  { name: 'Light Red', value: '#FF474C' },
  { name: 'Light Rose', value: '#FFC5CB' },
  { name: 'Light Royal Blue', value: '#3A2EFE' },
  { name: 'Light Sage', value: '#BCECAC' },
  { name: 'Light Salmon', value: '#FEA993' },
  { name: 'Light Seafoam Green', value: '#A7FFB5' },
  { name: 'Light Seafoam', value: '#A0FEBF' },
  { name: 'Light Sea Green', value: '#98F6B0' },
  { name: 'Light Sky Blue', value: '#C6FCFF' },
  { name: 'Light Tan', value: '#FBEEAC' },
  { name: 'Light Teal', value: '#90E4C1' },
  { name: 'Light Turquoise', value: '#7EF4CC' },
  { name: 'Light Urple', value: '#B36FF6' },
  { name: 'Light Violet', value: '#D6B4FC' },
  { name: 'Light Yellow Green', value: '#CCFD7F' },
  { name: 'Light Yellowish Green', value: '#C2FF89' },
  { name: 'Light Yellow', value: '#FFFE7A' },
  { name: 'Lilac', value: '#CEA2FD' },
  { name: 'Liliac', value: '#C48EFD' },
  { name: 'Lime Green', value: '#89FE05' },
  { name: 'Lime', value: '#AAFF32' },
  { name: 'Lime Yellow', value: '#D0FE1D' },
  { name: 'Lipstick Red', value: '#C0022F' },
  { name: 'Lipstick', value: '#D5174E' },
  { name: 'Macaroni and Cheese', value: '#EFB435' },
  { name: 'Magenta', value: '#C20078' },
  { name: 'Mahogany', value: '#4A0100' },
  { name: 'Maize', value: '#F4D054' },
  { name: 'Mango', value: '#FFA62B' },
  { name: 'Manilla', value: '#FFFA86' },
  { name: 'Marigold', value: '#FCC006' },
  { name: 'Marine Blue', value: '#01386A' },
  { name: 'Marine', value: '#042E60' },
  { name: 'Maroon', value: '#650021' },
  { name: 'Mauve', value: '#AE7181' },
  { name: 'Medium Blue', value: '#2C6FBB' },
  { name: 'Medium Brown', value: '#7F5112' },
  { name: 'Medium Green', value: '#39AD48' },
  { name: 'Medium Grey', value: '#7D7F7C' },
  { name: 'Medium Pink', value: '#F36196' },
  { name: 'Medium Purple', value: '#9E43A2' },
  { name: 'Melon', value: '#FF7855' },
  { name: 'Merlot', value: '#730039' },
  { name: 'Metallic Blue', value: '#4F738E' },
  { name: 'Mid Blue', value: '#276AB3' },
  { name: 'Mid Green', value: '#50A747' },
  { name: 'Midnight Blue', value: '#020035' },
  { name: 'Midnight Purple', value: '#280137' },
  { name: 'Midnight', value: '#03012D' },
  { name: 'Military Green', value: '#667C3E' },
  { name: 'Milk Chocolate', value: '#7F4E1E' },
  { name: 'Mint Green', value: '#8FFF9F' },
  { name: 'Mint', value: '#9FFEB0' },
  { name: 'Minty Green', value: '#0BF77D' },
  { name: 'Mocha', value: '#9D7651' },
  { name: 'Moss Green', value: '#658B38' },
  { name: 'Moss', value: '#769958' },
  { name: 'Mossy Green', value: '#638B27' },
  { name: 'Mud Brown', value: '#60460F' },
  { name: 'Muddy Brown', value: '#886806' },
  { name: 'Muddy Green', value: '#657432' },
  { name: 'Muddy Yellow', value: '#BFAC05' },
  { name: 'Mud Green', value: '#606602' },
  { name: 'Mud', value: '#735C12' },
  { name: 'Mulberry', value: '#920A4E' },
  { name: 'Murky Green', value: '#6C7A0E' },
  { name: 'Mushroom', value: '#BA9E88' },
  { name: 'Mustard Brown', value: '#AC7E04' },
  { name: 'Mustard Green', value: '#A8B504' },
  { name: 'Mustard', value: '#CEB301' },
  { name: 'Mustard Yellow', value: '#D2BD0A' },
  { name: 'Muted Blue', value: '#3B719F' },
  { name: 'Muted Green', value: '#5FA052' },
  { name: 'Muted Pink', value: '#D1768F' },
  { name: 'Muted Purple', value: '#805B87' },
  { name: 'Nasty Green', value: '#70B23F' },
  { name: 'Navy Blue', value: '#001146' },
  { name: 'Navy Green', value: '#35530A' },
  { name: 'Navy', value: '#01153E' },
  { name: 'Neon Blue', value: '#04D9FF' },
  { name: 'Neon Green', value: '#0CFF0C' },
  { name: 'Neon Pink', value: '#FE019A' },
  { name: 'Neon Purple', value: '#BC13FE' },
  { name: 'Neon Red', value: '#FF073A' },
  { name: 'Neon Yellow', value: '#CFFF04' },
  { name: 'Nice Blue', value: '#107AB0' },
  { name: 'Night Blue', value: '#040348' },
  { name: 'Ocean Blue', value: '#03719C' },
  { name: 'Ocean Green', value: '#3D9973' },
  { name: 'Ocean', value: '#017B92' },
  { name: 'Ocher', value: '#BF9B0C' },
  { name: 'Ochre', value: '#BF9005' },
  { name: 'Ocre', value: '#C69C04' },
  { name: 'Off Blue', value: '#5684AE' },
  { name: 'Off Green', value: '#6BA353' },
  { name: 'Off White', value: '#FFFFE4' },
  { name: 'Off Yellow', value: '#F1F33F' },
  { name: 'Old Pink', value: '#C77986' },
  { name: 'Old Rose', value: '#C87F89' },
  { name: 'Olive Brown', value: '#645403' },
  { name: 'Olive Drab', value: '#6F7632' },
  { name: 'Olive Green', value: '#677A04' },
  { name: 'Olive', value: '#6E750E' },
  { name: 'Olive Yellow', value: '#C2B709' },
  { name: 'Orange Brown', value: '#BE6400' },
  { name: 'Orangeish', value: '#FD8D49' },
  { name: 'Orange Pink', value: '#FF6F52' },
  { name: 'Orange Red', value: '#FD411E' },
  { name: 'Orangered', value: '#FE420F' },
  { name: 'Orange', value: '#F97306' },
  { name: 'Orangey Brown', value: '#B16002' },
  { name: 'Orange Yellow', value: '#FFAD01' },
  { name: 'Orangey Red', value: '#FA4224' },
  { name: 'Orangey Yellow', value: '#FDB915' },
  { name: 'Orangish Brown', value: '#B25F03' },
  { name: 'Orangish Red', value: '#F43605' },
  { name: 'Orangish', value: '#FC824A' },
  { name: 'Orchid', value: '#C875C4' },
  { name: 'Pale Aqua', value: '#B8FFEB' },
  { name: 'Pale Blue', value: '#D0FEFE' },
  { name: 'Pale Brown', value: '#B1916E' },
  { name: 'Pale Cyan', value: '#B7FFFA' },
  { name: 'Pale Gold', value: '#FDDE6C' },
  { name: 'Pale Green', value: '#C7FDB5' },
  { name: 'Pale Grey', value: '#FDFDFE' },
  { name: 'Pale Lavender', value: '#EECFFE' },
  { name: 'Pale Light Green', value: '#B1FC99' },
  { name: 'Pale Lilac', value: '#E4CBFF' },
  { name: 'Pale Lime Green', value: '#B1FF65' },
  { name: 'Pale Lime', value: '#BEFD73' },
  { name: 'Pale Magenta', value: '#D767AD' },
  { name: 'Pale Mauve', value: '#FED0FC' },
  { name: 'Pale Olive Green', value: '#B1D27B' },
  { name: 'Pale Olive', value: '#B9CC81' },
  { name: 'Pale Orange', value: '#FFA756' },
  { name: 'Pale Peach', value: '#FFE5AD' },
  { name: 'Pale Pink', value: '#FFCFDC' },
  { name: 'Pale Purple', value: '#B790D4' },
  { name: 'Pale Red', value: '#D9544D' },
  { name: 'Pale Rose', value: '#FDC1C5' },
  { name: 'Pale Salmon', value: '#FFB19A' },
  { name: 'Pale Sky Blue', value: '#BDF6FE' },
  { name: 'Pale Teal', value: '#82CBB2' },
  { name: 'Pale Turquoise', value: '#A5FBD5' },
  { name: 'Pale', value: '#FFF9D0' },
  { name: 'Pale Violet', value: '#CEAEFA' },
  { name: 'Pale Yellow', value: '#FFFF84' },
  { name: 'Parchment', value: '#FEFCAF' },
  { name: 'Pastel Blue', value: '#A2BFFE' },
  { name: 'Pastel Green', value: '#B0FF9D' },
  { name: 'Pastel Orange', value: '#FF964F' },
  { name: 'Pastel Pink', value: '#FFBACD' },
  { name: 'Pastel Purple', value: '#CAA0FF' },
  { name: 'Pastel Red', value: '#DB5856' },
  { name: 'Pastel Yellow', value: '#FFFE71' },
  { name: 'Peach', value: '#FFB07C' },
  { name: 'Peachy Pink', value: '#FF9A8A' },
  { name: 'Peacock Blue', value: '#016795' },
  { name: 'Pea Green', value: '#8EAB12' },
  { name: 'Pear', value: '#CBF85F' },
  { name: 'Pea Soup Green', value: '#94A617' },
  { name: 'Pea Soup', value: '#929901' },
  { name: 'Pea', value: '#A4BF20' },
  { name: 'Periwinkle Blue', value: '#8F99FB' },
  { name: 'Periwinkle', value: '#8E82FE' },
  { name: 'Perrywinkle', value: '#8F8CE7' },
  { name: 'Petrol', value: '#005F6A' },
  { name: 'Pig Pink', value: '#E78EA5' },
  { name: 'Pine Green', value: '#0A481E' },
  { name: 'Pine', value: '#2B5D34' },
  { name: 'Pinkish Brown', value: '#B17261' },
  { name: 'Pinkish Grey', value: '#C8ACA9' },
  { name: 'Pinkish Orange', value: '#FF724C' },
  { name: 'Pinkish Purple', value: '#D648D7' },
  { name: 'Pinkish Red', value: '#F10C45' },
  { name: 'Pinkish Tan', value: '#D99B82' },
  { name: 'Pinkish', value: '#D46A7E' },
  { name: 'Pink Purple', value: '#DB4BDA' },
  { name: 'Pink Purple', value: '#EF1DE7' },
  { name: 'Pink Red', value: '#F5054F' },
  { name: 'Pink', value: '#FF81C0' },
  { name: 'Pinky Purple', value: '#C94CBE' },
  { name: 'Pinky Red', value: '#FC2647' },
  { name: 'Pinky', value: '#FC86AA' },
  { name: 'Piss Yellow', value: '#DDD618' },
  { name: 'Pistachio', value: '#C0FA8B' },
  { name: 'Plum Purple', value: '#4E0550' },
  { name: 'Plum', value: '#580F41' },
  { name: 'Poison Green', value: '#40FD14' },
  { name: 'Poo Brown', value: '#885F01' },
  { name: 'Poop Brown', value: '#7A5901' },
  { name: 'Poop Green', value: '#6F7C00' },
  { name: 'Poop', value: '#7F5E00' },
  { name: 'Poo', value: '#8F7303' },
  { name: 'Powder Blue', value: '#B1D1FC' },
  { name: 'Powder Pink', value: '#FFB2D0' },
  { name: 'Primary Blue', value: '#0804F9' },
  { name: 'Prussian Blue', value: '#004577' },
  { name: 'Puce', value: '#A57E52' },
  { name: 'Puke Brown', value: '#947706' },
  { name: 'Puke Green', value: '#9AAE07' },
  { name: 'Puke', value: '#A5A502' },
  { name: 'Puke Yellow', value: '#C2BE0E' },
  { name: 'Pumpkin Orange', value: '#FB7D07' },
  { name: 'Pumpkin', value: '#E17701' },
  { name: 'Pure Blue', value: '#0203E2' },
  { name: 'Purple Blue', value: '#5D21D0' },
  { name: 'Purple Blue', value: '#632DE9' },
  { name: 'Purple Brown', value: '#673A3F' },
  { name: 'Purple Grey', value: '#866F85' },
  { name: 'Purpleish Blue', value: '#6140EF' },
  { name: 'Purpleish Pink', value: '#DF4EC8' },
  { name: 'Purpleish', value: '#98568D' },
  { name: 'Purple Pink', value: '#D725DE' },
  { name: 'Purple Pink', value: '#E03FD8' },
  { name: 'Purple Red', value: '#990147' },
  { name: 'Purple', value: '#7E1E9C' },
  { name: 'Purpley Blue', value: '#5F34E7' },
  { name: 'Purpley Grey', value: '#947E94' },
  { name: 'Purpley Pink', value: '#C83CB9' },
  { name: 'Purpley', value: '#8756E4' },
  { name: 'Purplish Blue', value: '#601EF9' },
  { name: 'Purplish Brown', value: '#6B4247' },
  { name: 'Purplish Grey', value: '#7A687F' },
  { name: 'Purplish Pink', value: '#CE5DAE' },
  { name: 'Purplish Red', value: '#B0054B' },
  { name: 'Purplish', value: '#94568C' },
  { name: 'Purply Blue', value: '#661AEE' },
  { name: 'Purply Pink', value: '#F075E6' },
  { name: 'Purply', value: '#983FB2' },
  { name: 'Putty', value: '#BEAE8A' },
  { name: 'Racing Green', value: '#014600' },
  { name: 'Radioactive Green', value: '#2CFA1F' },
  { name: 'Raspberry', value: '#B00149' },
  { name: 'Raw Sienna', value: '#9A6200' },
  { name: 'Raw Umber', value: '#A75E09' },
  { name: 'Really Light Blue', value: '#D4FFFF' },
  { name: 'Red Brown', value: '#8B2E16' },
  { name: 'Reddish Brown', value: '#7F2B0A' },
  { name: 'Reddish Grey', value: '#997570' },
  { name: 'Reddish Orange', value: '#F8481C' },
  { name: 'Reddish Pink', value: '#FE2C54' },
  { name: 'Reddish Purple', value: '#910951' },
  { name: 'Reddish', value: '#C44240' },
  { name: 'Reddy Brown', value: '#6E1005' },
  { name: 'Red Orange', value: '#FD3C06' },
  { name: 'Red Pink', value: '#FA2A55' },
  { name: 'Red Purple', value: '#820747' },
  { name: 'Red', value: '#E50000' },
  { name: 'Red Violet', value: '#9E0168' },
  { name: 'Red Wine', value: '#8C0034' },
  { name: 'Rich Blue', value: '#021BF9' },
  { name: 'Rich Purple', value: '#720058' },
  { name: 'Robin Egg Blue', value: '#8AF1FE' },
  { name: 'Robin Egg Blue', value: '#98EFF9' },
  { name: 'Robin Egg', value: '#6DEDFD' },
  { name: 'Rosa', value: '#FE86A4' },
  { name: 'Rose Pink', value: '#F7879A' },
  { name: 'Rose Red', value: '#BE013C' },
  { name: 'Rose', value: '#CF6275' },
  { name: 'Rosy Pink', value: '#F6688E' },
  { name: 'Rouge', value: '#AB1239' },
  { name: 'Royal Blue', value: '#0504AA' },
  { name: 'Royal Purple', value: '#4B006E' },
  { name: 'Royal', value: '#0C1793' },
  { name: 'Ruby', value: '#CA0147' },
  { name: 'Russet', value: '#A13905' },
  { name: 'Rust Brown', value: '#8B3103' },
  { name: 'Rust Orange', value: '#C45508' },
  { name: 'Rust Red', value: '#AA2704' },
  { name: 'Rust', value: '#A83C09' },
  { name: 'Rusty Orange', value: '#CD5909' },
  { name: 'Rusty Red', value: '#AF2F0D' },
  { name: 'Saffron', value: '#FEB209' },
  { name: 'Sage Green', value: '#88B378' },
  { name: 'Sage', value: '#87AE73' },
  { name: 'Salmon Pink', value: '#FE7B7C' },
  { name: 'Salmon', value: '#FF796C' },
  { name: 'Sand Brown', value: '#CBA560' },
  { name: 'Sandstone', value: '#C9AE74' },
  { name: 'Sand', value: '#E2CA76' },
  { name: 'Sandy Brown', value: '#C4A661' },
  { name: 'Sand Yellow', value: '#FCE166' },
  { name: 'Sandy', value: '#F1DA7A' },
  { name: 'Sandy Yellow', value: '#FDEE73' },
  { name: 'Sap Green', value: '#5C8B15' },
  { name: 'Sapphire', value: '#2138AB' },
  { name: 'Scarlet', value: '#BE0119' },
  { name: 'Sea Blue', value: '#047495' },
  { name: 'Seafoam Blue', value: '#78D1B6' },
  { name: 'Seafoam Green', value: '#7AF9AB' },
  { name: 'Seafoam', value: '#80F9AD' },
  { name: 'Sea Green', value: '#53FCA1' },
  { name: 'Sea', value: '#3C9992' },
  { name: 'Seaweed Green', value: '#35AD6B' },
  { name: 'Seaweed', value: '#18D17B' },
  { name: 'Sepia', value: '#985E2B' },
  { name: 'Shamrock Green', value: '#02C14D' },
  { name: 'Shamrock', value: '#01B44C' },
  { name: 'Shocking Pink', value: '#FE02A2' },
  { name: 'Sick Green', value: '#9DB92C' },
  { name: 'Sickly Green', value: '#94B21C' },
  { name: 'Sickly Yellow', value: '#D0E429' },
  { name: 'Sienna', value: '#A9561E' },
  { name: 'Silver', value: '#C5C9C7' },
  { name: 'Sky Blue', value: '#75BBFD' },
  { name: 'Sky', value: '#82CAFC' },
  { name: 'Slate Blue', value: '#5B7C99' },
  { name: 'Slate Green', value: '#658D6D' },
  { name: 'Slate Grey', value: '#59656D' },
  { name: 'Slate', value: '#516572' },
  { name: 'Slime Green', value: '#99CC04' },
  { name: 'Snot Green', value: '#9DC100' },
  { name: 'Snot', value: '#ACBB0D' },
  { name: 'Soft Blue', value: '#6488EA' },
  { name: 'Soft Green', value: '#6FC276' },
  { name: 'Soft Pink', value: '#FDB0C0' },
  { name: 'Soft Purple', value: '#A66FB5' },
  { name: 'Spearmint', value: '#1EF876' },
  { name: 'Spring Green', value: '#A9F971' },
  { name: 'Spruce', value: '#0A5F38' },
  { name: 'Squash', value: '#F2AB15' },
  { name: 'Steel Blue', value: '#5A7D9A' },
  { name: 'Steel Grey', value: '#6F828A' },
  { name: 'Steel', value: '#738595' },
  { name: 'Stone', value: '#ADA587' },
  { name: 'Stormy Blue', value: '#507B9C' },
  { name: 'Strawberry', value: '#FB2943' },
  { name: 'Straw', value: '#FCF679' },
  { name: 'Strong Blue', value: '#0C06F7' },
  { name: 'Strong Pink', value: '#FF0789' },
  { name: 'Sunflower', value: '#FFC512' },
  { name: 'Sunflower Yellow', value: '#FFDA03' },
  { name: 'Sunny Yellow', value: '#FFF917' },
  { name: 'Sunshine Yellow', value: '#FFFD37' },
  { name: 'Sun Yellow', value: '#FFDF22' },
  { name: 'Swamp Green', value: '#748500' },
  { name: 'Swamp', value: '#698339' },
  { name: 'Tan Brown', value: '#AB7E4C' },
  { name: 'Tangerine', value: '#FF9408' },
  { name: 'Tan Green', value: '#A9BE70' },
  { name: 'Tan', value: '#D1B26F' },
  { name: 'Taupe', value: '#B9A281' },
  { name: 'Tea Green', value: '#BDF8A3' },
  { name: 'Teal Blue', value: '#01889F' },
  { name: 'Teal Green', value: '#25A36F' },
  { name: 'Tealish Green', value: '#0CDC73' },
  { name: 'Tealish', value: '#24BCA8' },
  { name: 'Teal', value: '#029386' },
  { name: 'Tea', value: '#65AB7C' },
  { name: 'Terracota', value: '#CB6843' },
  { name: 'Terra Cotta', value: '#C9643B' },
  { name: 'Terracotta', value: '#CA6641' },
  { name: 'Tiffany Blue', value: '#7BF2DA' },
  { name: 'Tomato Red', value: '#EC2D01' },
  { name: 'Tomato', value: '#EF4026' },
  { name: 'Topaz', value: '#13BBAF' },
  { name: 'Toupe', value: '#C7AC7D' },
  { name: 'Toxic Green', value: '#61DE2A' },
  { name: 'Tree Green', value: '#2A7E19' },
  { name: 'True Blue', value: '#010FCC' },
  { name: 'True Green', value: '#089404' },
  { name: 'Turquoise Blue', value: '#06B1C4' },
  { name: 'Turquoise Green', value: '#04F489' },
  { name: 'Turquoise', value: '#06C2AC' },
  { name: 'Turtle Green', value: '#75B84F' },
  { name: 'Twilight Blue', value: '#0A437A' },
  { name: 'Twilight', value: '#4E518B' },
  { name: 'Ugly Blue', value: '#31668A' },
  { name: 'Ugly Brown', value: '#7D7103' },
  { name: 'Ugly Green', value: '#7A9703' },
  { name: 'Ugly Pink', value: '#CD7584' },
  { name: 'Ugly Purple', value: '#A442A0' },
  { name: 'Ugly Yellow', value: '#D0C101' },
  { name: 'Ultramarine Blue', value: '#1805DB' },
  { name: 'Ultramarine', value: '#2000B1' },
  { name: 'Umber', value: '#B26400' },
  { name: 'Velvet', value: '#750851' },
  { name: 'Vermillion', value: '#F4320C' },
  { name: 'Very Dark Blue', value: '#000133' },
  { name: 'Very Dark Brown', value: '#1D0200' },
  { name: 'Very Dark Green', value: '#062E03' },
  { name: 'Very Dark Purple', value: '#2A0134' },
  { name: 'Very Light Blue', value: '#D5FFFF' },
  { name: 'Very Light Brown', value: '#D3B683' },
  { name: 'Very Light Green', value: '#D1FFBD' },
  { name: 'Very Light Pink', value: '#FFF4F2' },
  { name: 'Very Light Purple', value: '#F6CEFC' },
  { name: 'Very Pale Blue', value: '#D6FFFE' },
  { name: 'Very Pale Green', value: '#CFFDBC' },
  { name: 'Vibrant Blue', value: '#0339F8' },
  { name: 'Vibrant Green', value: '#0ADD08' },
  { name: 'Vibrant Purple', value: '#AD03DE' },
  { name: 'Violet Blue', value: '#510AC9' },
  { name: 'Violet Pink', value: '#FB5FFC' },
  { name: 'Violet Red', value: '#A50055' },
  { name: 'Violet', value: '#9A0EEA' },
  { name: 'Viridian', value: '#1E9167' },
  { name: 'Vivid Blue', value: '#152EFF' },
  { name: 'Vivid Green', value: '#2FEF10' },
  { name: 'Vivid Purple', value: '#9900FA' },
  { name: 'Vomit Green', value: '#89A203' },
  { name: 'Vomit', value: '#A2A415' },
  { name: 'Vomit Yellow', value: '#C7C10C' },
  { name: 'Warm Blue', value: '#4B57DB' },
  { name: 'Warm Brown', value: '#964E02' },
  { name: 'Warm Grey', value: '#978A84' },
  { name: 'Warm Pink', value: '#FB5581' },
  { name: 'Warm Purple', value: '#952E8F' },
  { name: 'Washed Out Green', value: '#BCF5A6' },
  { name: 'Water Blue', value: '#0E87CC' },
  { name: 'Watermelon', value: '#FD4659' },
  { name: 'Weird Green', value: '#3AE57F' },
  { name: 'Wheat', value: '#FBDD7E' },
  { name: 'White', value: '#FFFFFF' },
  { name: 'Windows Blue', value: '#3778BF' },
  { name: 'Wine Red', value: '#7B0323' },
  { name: 'Wine', value: '#80013F' },
  { name: 'Wintergreen', value: '#20F986' },
  { name: 'Wisteria', value: '#A87DC2' },
  { name: 'Yellow Brown', value: '#B79400' },
  { name: 'Yellowgreen', value: '#BBF90F' },
  { name: 'Yellow Green', value: '#C0FB2D' },
  { name: 'Yellow Green', value: '#C8FD3D' },
  { name: 'Yellowish Brown', value: '#9B7A01' },
  { name: 'Yellowish Green', value: '#B0DD16' },
  { name: 'Yellowish Orange', value: '#FFAB0F' },
  { name: 'Yellowish Tan', value: '#FCFC81' },
  { name: 'Yellowish', value: '#FAEE66' },
  { name: 'Yellow Ochre', value: '#CB9D06' },
  { name: 'Yellow Orange', value: '#FCB001' },
  { name: 'Yellow Tan', value: '#FFE36E' },
  { name: 'Yellow', value: '#FFFF14' },
  { name: 'Yellowy Brown', value: '#AE8B0C' },
  { name: 'Yellowy Green', value: '#BFF128' }
];
